"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSoftFactsProperty = exports.softFactsPropertyDefinition = void 0;
exports.softFactsPropertyDefinition = {
    view: {
        label: 'Soft facts',
        style: 'list-ordered',
    },
    constraints: [
        {
            name: 'maxLength',
            argument: 200,
        },
    ],
    type: 'rich-text',
    multiple: true,
    name: 'soft-facts',
};
const isSoftFactsProperty = (prop) => {
    return prop.name === exports.softFactsPropertyDefinition.name;
};
exports.isSoftFactsProperty = isSoftFactsProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic29mdC1mYWN0cy5wcm9wZXJ0eS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wcm9wZXJ0aWVzL3NvZnQtZmFjdHMucHJvcGVydHkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRWEsUUFBQSwyQkFBMkIsR0FBRztJQUN6QyxJQUFJLEVBQUU7UUFDSixLQUFLLEVBQUUsWUFBWTtRQUNuQixLQUFLLEVBQUUsY0FBYztLQUN0QjtJQUNELFdBQVcsRUFBRTtRQUNYO1lBQ0UsSUFBSSxFQUFFLFdBQVc7WUFDakIsUUFBUSxFQUFFLEdBQUc7U0FDZDtLQUNGO0lBQ0QsSUFBSSxFQUFFLFdBQVc7SUFDakIsUUFBUSxFQUFFLElBQUk7SUFDZCxJQUFJLEVBQUUsWUFBWTtDQUNhLENBQUE7QUFJMUIsTUFBTSxtQkFBbUIsR0FBRyxDQUFDLElBQWtCLEVBQTZCLEVBQUU7SUFDbkYsT0FBTyxJQUFJLENBQUMsSUFBSSxLQUFLLG1DQUEyQixDQUFDLElBQUksQ0FBQTtBQUN2RCxDQUFDLENBQUE7QUFGWSxRQUFBLG1CQUFtQix1QkFFL0IifQ==